/**
 * We use a global map, otherwise this seems to cause a big mess with i18next and caused a setState error there
 */
export const missingKeyState = new Map();
//# sourceMappingURL=missingKeyState.js.map